import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import AuthLayout, { Field } from "./AuthLayout";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    setLoading(false);
  };

  return (
    <AuthLayout title="Reset your password" subtitle="We'll email you a secure reset link"
      footer={<Link to="/login" className="text-blue-accent font-semibold">← Back to sign in</Link>}>
      {sent ? (
        <div className="amden-card p-6 bg-emerald-50 border-emerald-200" data-testid="forgot-confirmation">
          <p className="text-emerald-800">If that email is registered, a reset link has been sent. Check your inbox.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Field label="Email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" placeholder="you@business.com" />
          <button disabled={loading} data-testid="forgot-submit" className="w-full px-5 py-3 rounded-xl bg-navy hover:bg-slate-800 text-white font-semibold transition-colors disabled:opacity-60">
            {loading ? "Sending…" : "Send reset link"}
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
